import { useContext } from "react";
import { LoaderContext } from "../contexts";

const useLoader = () => useContext(LoaderContext);

export default useLoader;
